import { Card, CardContent } from "@altimateai/lego";
import IntegrationSelector from "../IntegrationSelector";
import { DismissibleAlertBanner } from "@/components/banners/DismissibleAlertBanner";
import MemoryToggle from "@/pages/teammate/dataMates/memory/MemoryToggle";

const Knowledge = () => {
  return (
    <div>
      <div className="al-my-4">
        <DismissibleAlertBanner
          bannerId="mcp-knowledge"
          content="Datamates that securely provide context to your AI Workflows across Interfaces and Data tools. All credentials are  processed locally for maximum security, enabling AI that understands your entire data ecosystem"
        />
      </div>

      <Card className="al-mb-4">
        <CardContent className="al-pt-4">
          <MemoryToggle showInfo />
        </CardContent>
      </Card>
      <IntegrationSelector />
    </div>
  );
};

export default Knowledge;
